/**
 * Excel invalid sheet chars: : \ / ? * [ ]
 *
 * @param {string} name
 * @returns {string} max 31 chars
 */
export function sanitizeExcelSheetName(name) {
  let s = String(name || 'Sheet');
  for (const ch of ':\\/*?[]') {
    s = s.split(ch).join(' ');
  }
  s = s.replace(/\s+/g, ' ').trim();
  if (!s) s = 'Sheet';
  return s.length > 31 ? s.slice(0, 31) : s;
}

/**
 * @param {string[][]} matrix
 * @returns {Array<{ wch: number }>}
 */
function columnWidthsFromMatrix(matrix) {
  if (!matrix.length) {
    return [];
  }
  const colCount = matrix[0].length;
  const widths = [];
  for (let c = 0; c < colCount; c += 1) {
    let max = 10;
    for (let r = 0; r < matrix.length; r += 1) {
      const cell = matrix[r][c];
      const len = cell != null ? String(cell).length : 0;
      if (len > max) max = len;
    }
    widths.push({ wch: Math.min(max + 2, 80) });
  }
  return widths;
}

/**
 * @param {object} params
 * @param {string[][]} params.matrix
 * @param {string} params.sheetTitle
 * @param {string} params.filename full filename including `.xlsx`
 * @returns {Promise<void>}
 */
export async function downloadExcelFromMatrix({ matrix, sheetTitle, filename }) {
  const XLSX = await import('xlsx');
  if (!matrix.length) {
    throw new Error('No data to export');
  }
  const ws = XLSX.utils.aoa_to_sheet(matrix);
  ws['!cols'] = columnWidthsFromMatrix(matrix);
  const wb = XLSX.utils.book_new();
  const sheetName = sanitizeExcelSheetName(sheetTitle);
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const safeName = String(filename || 'export.xlsx').toLowerCase().endsWith('.xlsx')
    ? filename
    : `${filename}.xlsx`;
  XLSX.writeFile(wb, safeName);
}
